import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import TaskPayRowsTableRow from './TaskPayRowsTableRow';
import type { TaskPayReportItemType } from '@econtractor/types';

interface TaskPayRowsTableBodyProps {
    rows: TaskPayReportItemType[];
}

const TaskPayRowsTableBody = ({ rows }: TaskPayRowsTableBodyProps) => {
    const { t } = useTranslation(['Reports']);

    if (!rows.length) {
        return (
            <tbody>
                <TableEmptyRow colSpan={6} className="text-center text-muted py-3">
                    {t('tasksFields.emptyRows')}
                </TableEmptyRow>
            </tbody>
        );
    }

    return (
        <tbody>
            {rows.map((row) => (
                <TaskPayRowsTableRow key={row.taskId} row={row} />
            ))}
        </tbody>
    );
};

export default TaskPayRowsTableBody;
